import AppViewController from './AppViewController';

export default AppViewController;
